﻿(function (angular) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('tyAutocompleteOff', ['$timeout', function ($timeout) {
            return {
                scope: true,
                restrict: 'A',
                link: function (scope, $element) {
                    $timeout(function () {
                        $element.find('input').attr('autocomplete', 'address'); // see https://bugs.chromium.org/p/chromium/issues/detail?id=468153
                    });
                }
            };
        }]);
})(window.angular);
